import { Link } from "react-router-dom";

function NotFound() {
    return (
        <div
            className="container text-center"
            style={{ padding: "100px 20px" }}
        >
            <h1
                className="display-1 fw-bold text-danger"
            >
                404
            </h1>

            <h3>Page Not Found</h3>

            <p>
                The page you are looking for does not
                exist.
            </p>

            <Link
                to="/"
                className="btn btn-primary mt-3"
            >
                Back To Home
            </Link>
        </div>
    );
}

export default NotFound;